import { render, staticRenderFns } from "./mxkAuthorization.vue?vue&type=template&id=403a69ba&scoped=true&"
import script from "./mxkAuthorization.vue?vue&type=script&lang=js&"
export * from "./mxkAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./mxkAuthorization.vue?vue&type=style&index=0&id=403a69ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403a69ba",
  null
  
)

export default component.exports